import { render } from "./ManageRolesModal.vue?vue&type=template&id=f2e3f5c8&scoped=true"
import script from "./ManageRolesModal.vue?vue&type=script&lang=js"
export * from "./ManageRolesModal.vue?vue&type=script&lang=js"

import "./ManageRolesModal.vue?vue&type=style&index=0&id=f2e3f5c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e3f5c8"]])

export default __exports__